export const READ_ONLY_CHECKBOX_SX = {
  '&.Mui-disabled': { cursor: 'not-allowed' },
  '& .MuiButtonBase-root.Mui-disabled': {
    cursor: 'not-allowed',
    pointerEvents: 'auto',
  },
};
